import React from 'react';
import { sortBy } from 'lodash';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  TextField,
  MenuItem,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  MentionsInput,
  Mention,
} from 'react-mentions';
import User from '../User';
import styles from './styles';

const useStyles = makeStyles(styles);

const CustomInput = (props) => {
  const {
    inputRef,
    ...other
  } = props;
  const classes = useStyles();
  // redux state
  const barnUsers = useSelector((state) => state.barn.barnUsers);

  return (
    <MentionsInput
      {...other}
      allowSpaceInQuery
      inputRef={inputRef}
      allowSuggestionsAboveCursor
      className="mentions__input"
    >
      <Mention
        markup="@[__display__](__id__)"
        trigger="@"
        data={(search, callback) => {
          const term = search.toLocaleLowerCase();
          callback(sortBy(barnUsers, ['userFullName'])
            .filter((tenantUser) => (tenantUser.email
              && (tenantUser.userFullName.toLocaleLowerCase().indexOf(term) >= 0
                || tenantUser.email.toLocaleLowerCase().indexOf(term) >= 0)))
            .map((tenantUser) => ({
              id: tenantUser.auth0UserId,
              display: `@${tenantUser.userFullName}`,
              user: tenantUser,
            })).slice(0, 8));
        }}
        className={classes.mention}
        renderSuggestion={(
          suggestion,
          search,
          highlightedDisplay,
          index,
          focused,
        ) => (
          <MenuItem
            key={suggestion.user.auth0UserId}
            component="div"
            dense
            disableGutters
            className={focused
              ? classes.highlightedOption
              : classes.option}
          >
            <User user={suggestion.user} chip />
          </MenuItem>
        )}
      />
    </MentionsInput>
  );
};

CustomInput.propTypes = { inputRef: PropTypes.func.isRequired };

export const UserMentionTextFieldComponent = (props) => {
  const {
    value,
    label,
    onChange,
    required,
    disabled,
    error,
    helperText,
    rows,
  } = props;

  return (
    <TextField
      label={label}
      multiline
      fullWidth
      required={required}
      error={error}
      rows={rows}
      maxRows={rows}
      value={value || ''}
      disabled={disabled}
      onChange={onChange}
      helperText={helperText}
      variant="outlined"
      InputProps={{ inputComponent: CustomInput }}
    />
  );
};

UserMentionTextFieldComponent.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  rows: PropTypes.number,
};

UserMentionTextFieldComponent.defaultProps = {
  value: '',
  label: '',
  onChange: () => {},
  disabled: false,
  required: false,
  error: false,
  helperText: '',
  rows: 2,
};

export default UserMentionTextFieldComponent;
